// Basketball court dimensions (NBA half-court in meters)
export const COURT_DIMENSIONS = {
	WIDTH: 14,
	HEIGHT: 15,
	KEY_WIDTH: 4.9,
	KEY_HEIGHT: 5.8,
	FREE_THROW_LINE_DISTANCE: 5.8,
	FREE_THROW_CIRCLE_RADIUS: 1.8,
	THREE_POINT_RADIUS: 6.75,
	THREE_POINT_CORNER_DISTANCE: 0.9,
	THREE_POINT_STRAIGHT_DISTANCE: 4.5,
	BASKET_HEIGHT: 3.05,
	BASKET_RADIUS: 0.23,
	BASKET_POSITION_FROM_BASELINE: 1.575,
	LINE_WIDTH: 0.05,
};

export const CameraPreset = {
	TOP: {
		position: [0, 25, 0],
		rotation: [-Math.PI / 2, 0, 0],
		fov: 75,
		near: 0.1,
		far: 1000,
		zoom: 1.8,
	},
	FRONT: {
		position: [0, 15, 25],
		rotation: [0, 0, 0],
		fov: 60,
		near: 0.1,
		far: 1000,
		zoom: 1.3,
	},
	FRONT_LEFT: {
		position: [-20, 28, 20],
		rotation: [-0.2, -Math.PI / 4, 0],
		fov: 60,
		near: 0.1,
		far: 1000,
		zoom: 1.8,
	},
	FRONT_RIGHT: {
		position: [20, 28, 20],
		rotation: [-0.2, Math.PI / 4, 0],
		fov: 60,
		near: 0.1,
		far: 1000,
		zoom: 1.8,
	},
	LEFT: {
		position: [-35, 15, 0],
		rotation: [0, -Math.PI / 2, 0],
		fov: 60,
		near: 0.1,
		far: 1000,
		zoom: 1.8,
	},
	RIGHT: {
		position: [35, 15, 0],
		rotation: [0, Math.PI / 2, 0],
		fov: 60,
		near: 0.1,
		far: 1000,
		zoom: 1.8,
	},
};
